import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type DeleteEntityCardDialogProps = {
  entityTitle: string;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  submitting: boolean;
};

export function DeleteEntityCardDialog({
  entityTitle,
  onConfirm,
  onOpenChange,
  open,
  submitting,
}: DeleteEntityCardDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("entities.dialogs.deleteTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("entities.dialogs.deleteBody", { title: entityTitle })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction disabled={submitting} onClick={onConfirm}>
            {submitting
              ? t("entities.dialogs.deleting")
              : t("entities.dialogs.deleteConfirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
